import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useFlow } from "../context/FlowContext";
export default function Index(props) {
    const navigate = useNavigate();
    const flow = useFlow();
    useEffect(() => {
        navigate(`/oa_widget_${flow.views[0].route.route}`);
    }, []);
    return (_jsx(_Fragment, {}));
}
